module.exports = __webpack_public_path__ + "img/statistics_outlined_32.8fb37be1.svg";